<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-items-center wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Nav links</span>
      <span class="wf-w-1/2 wf-text-right">
        <a href="#" @click.prevent="openLinksModal" class="wf-underline wf-text-xs wf-text-blue-600 wf-mr-1">
          Update
        </a>
      </span>
    </li>
    <EditorNavLinksModal @submit="updateNavLinks"/>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  import EditorNavLinksModal from '../components/Layout/EditorNavLinksModal'
  export default MenuContentProperty.extend({
    components: {
      EditorNavLinksModal
    },
    methods: {
      openLinksModal() {
        this.$modal.show('nav-links-modal', {
          navLinks: this.elementContent.navLinks
        })
      },
      updateNavLinks(event) {
        this.addToObject(this.module, {navLinks: event}, 'content')
      }
    }
  })
</script>